import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';


export class RoleProductRate extends BaseEntity {

  role              : Role    = new Role();
  product           : Product = new Product();
  rate              : number;

  constructor() {
    super();
  }

}